'use client';

import {v4 as uuidv4} from 'uuid';
import PropTypes from "prop-types";
import React, {useState, useEffect, useCallback} from "react";

import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import useCommentListForRecipe from "src/hooks/comment/use-comment-list-for-recipe";

import {LoadingScreen} from "src/components/loading-screen";
import CommentItem from "src/components/comment/comment-item";
import CommentForm from "src/components/comment/comment-form";

function RecipeComments({recipeData}) {
  const [commmentListSize, setCommentListSize] = useState(10);

  const {
    commentList,
    isLoaded: isCommentListLoaded,
    loadCommentData,
    setIsLoaded: setIsCommentListLoaded
  } = useCommentListForRecipe(recipeData.pimcoreRecipeId);

  const handleShowMore = useCallback(() => {
    setCommentListSize(prev => prev + 10);
    setIsCommentListLoaded(false);
  }, [setIsCommentListLoaded, setCommentListSize]);

  useEffect(() => {
    loadCommentData(commmentListSize);
  }, [commmentListSize, loadCommentData]);

  return (
    <Stack direction="column" spacing={1}>
      <Typography variant="h5" sx={{flexGrow: 1}}>
        Komentarze
        {commentList.items?.length <= 0 && (
          <Typography variant="body2" color="text.secondary">
            Brak komentarzy
          </Typography>
        )}
      </Typography>
      <Stack direction="column" spacing={2}>
        <Typography variant="subtitle1">
          Dodaj komentarz
        </Typography>
        <CommentForm recipeId={parseInt(recipeData.pimcoreRecipeId, 10)} afterSubmit={useCallback(
          () => {
            loadCommentData();
          },
          [loadCommentData]
        )}/>
      </Stack>
      <Divider sx={{my: 2}}/>
      <Stack direction="column" spacing={2}>
        {commentList.items?.map(comment => (
          <CommentItem key={`${uuidv4()}-${comment.id}`} comment={comment} recipeData={recipeData}/>
        ))}
        {!isCommentListLoaded && (
          <LoadingScreen sx={{mt: 1}}/>
        )}
      </Stack>
      {(isCommentListLoaded && commentList.totalCount > commentList.items?.length) && (
        <Stack direction="row" sx={{justifyContent: 'center'}}>
          <Button sx={{width: {xs: '100%', sm: 'auto'}}} color="primary" variant="outlined" onClick={handleShowMore}>
            Załaduj więcej komentarzy
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

RecipeComments.propTypes = {
  recipeData: PropTypes.object
}
export default RecipeComments;
